module.exports = __webpack_public_path__ + "static/media/list-ordered.51e52c3e.svg";